import Api, { FetchMethodType } from 'api/Api';

export default class StatusApi extends Api {
  public fetchStatus() {
    return this.fetch<string>('/status', {
      method: FetchMethodType.GET,
    });
  }
}
